import { c as _c } from "react/compiler-runtime";
import { StadiaPlaygroundMap } from '~/components/Playground/StadiaPlaygroundMap';
// Locale-stripped, so the remount key is `build`/`review` on every locale rather than `/en-USbuild`.
import { usePathname } from '~/i18n/navigation';
export default function PlaygroundMap() {
  const $ = _c(4);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = pathname?.replace("/map/", "");
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const path = t0;
  let t1;
  if ($[2] !== path) {
    t1 = <div className="flex-1 w-full min-h-0"><StadiaPlaygroundMap key={path} /></div>;
    $[2] = path;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}